<template>
  <div>
      <a-upload
        name="file"
        :fileList="fileList"
        :beforeUpload="beforeUpload"
        @change="handleChange"
        :remove="remove"
      >
        <a-button>
          <a-icon type="upload"/>
          Subir archivo
        </a-button>
      </a-upload>
      <br>
      <a-button type="primary" :loading="loading" @click="subirArchivo">
        <a-icon type="up-circle"/>
        Cargar
      </a-button>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane key="1">
        <span slot="tab">
          <a-icon type="code"/>
          LOG VALIDACIONES
        </span>
        <span v-if="successMessage.length > 0">
            <a-result
              status="success"
              :title="successMessage"
              :sub-title="messageCant"
            >
            </a-result>
        </span>
        <span v-else>
          <a-input-search v-if="!loading" style="margin-bottom: 8px;max-width: 300px" placeholder="Buscar..." v-model="value"/>
          <div class="scroll-wiki">
            <a-tree autoExpandParent defaultExpandAll :key="key">
              <a-tree-node  v-for="(msg, index) in filtreMessage" :key="index">
                <span slot="title"><a-tag color="#e53935">Error - {{index + 1}}</a-tag></span>
                <a-tree-node :key="ind" v-for="(error, ind) in msg">
                  <span slot="title"> <a-icon type="close-circle" theme="twoTone" two-tone-color="red"/> {{error}}</span>
                </a-tree-node>
              </a-tree-node>
            </a-tree>
          </div>
        </span>
      </a-tab-pane>
      <a-tab-pane key="2">
        <span slot="tab">
          <a-icon type="snippets"/>
          HISTORICO CARGUES
        </span>
        <cargue-historico-dist @loadData="loadData" ref="hist"/>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    mounted () {
      this.httpClient = new HttpUtil()
      this.httpClientUploader = this.httpClient.getNewInstance()
      this.httpClientUploader.defaults.headers['Content-Type'] = 'multipart/form-data'
    },
    data () {
      return {
        iForm: {},
        fileList: [],
        statusFile: true,
        message: [],
        loading: false,
        visible: false,
        successMessage: '',
        value: null,
        searchLine: null,
        key: 0,
        cantidad: 0
      }
    },
    methods: {
      beforeUpload (file) {
        const supportType = [
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ]
        let extType = supportType.includes(file.type)
        if (!extType) {
          this.$message.error('Solo se pemiten archivos de extensión Excel')
        }
        const isLt2M = file.size / 1024 / 1024 < 10
        this.statusFile = extType && isLt2M
        if (!isLt2M) {
          this.$message.error('El tamaño del archivo no puede ser mayor a 10 Megas.')
          return false
        }
        return false
      },
      handleChange ({file}) {
        if (this.statusFile) {
          this.fileList = [file]
        } else {
          this.fileList = []
        }
      },
      remove () {
        this.fileList.pop()
        return true
      },

      // CARGAR EL ARCHIVO
      subirArchivo () {
        if (this.fileList.length > 0) {
          let request = new FormData()
          this.loading = true
          this.message = ''
          this.cantidad = 0
          request.append('document', this.fileList[0])
          this.httpClientUploader.post('document_dist/upload', request)
            .then((response) => {
              let resp = response.data
              if (this.$isEmpty(resp.message)) {
                this.successMessage = 'El cargue fue exitoso.'
                this.cantidad = resp.cantidad
              } else {
                this.message = resp.message
                this.key++
              }
              if (!resp.status) {
                Mensajes.error('Error', 'No fue posible realizar el cargue masivo.')
                return
              }
              Mensajes.success('Correcto', 'Se realizo con éxito')
              this.$refs.hist && this.$refs.hist.loadData()
            })
            .catch((error) => {
              Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible realizar el cargue masivo.'))
            })
            .then(() => {
              this.loading = false
            })
        } else {
          Mensajes.error('Error', 'Debes de cargar un archivo.')
        }
      },
      loadData () {
        this.$emit('loadData')
      }
    },
    computed: {
      filtreMessage () {
        if (this.$isEmpty(this.value)) {
          return this.message
        } else {
          let value = this.value.toUpperCase()
          if (value.includes('LINEA')) {
            let index = value.split(' ')[1]
            return this.message.filter((messages, ind) => ind === index - 1)
          } else {
            return this.message.filter(messages => {
              return messages.some(element => {
                return element.toUpperCase().includes(value)
              })
            })
          }
        }
      },
      messageCant () {
        return `Se cargaron ${this.cantidad} novedades ocasionales.`
      }
    }
  }
</script>
<style>
  .scroll-wiki {
    text-align: justify;
    text-justify: inter-word;
    max-height: 300px !important;
    overflow-y: auto
  }
</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/CargueMasivo/CargueDist.vue